/* eslint-disable react/no-danger */

import React from 'react';

import './AnnouncementBar.scss';

const AnnouncementBar = ({ 'announcement-bar': content }) => {
  if (!content) return null;

  return <div className="announcement-bar" dangerouslySetInnerHTML={{ __html: content }} />;
};

export default AnnouncementBar;
